export default __webpack_public_path__ + "60063f41d03e785e3db15c81c4ebd30f.svg";